var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.69998 13.56C3.03998 14.22 2.11998 17.24 2.01998 17.58C1.97998 17.74 2.05998 17.92 2.23998 17.96C2.25998 17.96 2.29998 17.98 2.31998 17.98C2.33998 17.98 2.37998 17.98 2.39998 17.96C2.73998 17.86 5.75998 16.94 6.41998 16.28C7.17998 15.52 7.17998 14.3 6.41998 13.56C5.67998 12.82 4.45998 12.82 3.69998 13.56Z",
    fill: "#8F8C9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8 2.55999C17.76 2.37999 17.62 2.25999 17.44 2.19999C16.66 2.03999 15.84 1.97999 15.04 1.99999C12.04 1.99999 10.24 3.59999 8.9 5.71999H5.88C5.36 5.73999 4.9 6.03999 4.64 6.47999L3.2 9.35999C3.16 9.45999 3.14 9.55999 3.12 9.67999C3.12 10.06 3.44 10.38 3.82 10.38H6.84L6.2 11.02C5.84 11.38 5.84 11.96 6.2 12.34L7.68 13.82C8.04 14.18 8.62 14.18 9 13.82L9.65999 13.16V16.18C9.65999 16.56 9.95999 16.88 10.36 16.88C10.46 16.88 10.56 16.86 10.66 16.82L13.52 15.38C13.98 15.12 14.26 14.66 14.28 14.14V11.08C16.4 9.73999 18 7.93999 18 4.95999C18.02 4.15999 17.96 3.35999 17.8 2.55999ZM14.28 6.87999C13.64 6.87999 13.12 6.35999 13.12 5.71999C13.12 5.07999 13.64 4.55999 14.28 4.55999C14.92 4.55999 15.44 5.07999 15.44 5.71999C15.44 6.35999 14.92 6.87999 14.28 6.87999Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductivity);
export default __webpack_public_path__ + "static/media/productivity.74a9575e6373b0106678ef6823f1a516.svg";
export { ForwardRef as ReactComponent };